<template>
  <div>
    <AppMenu />
    <BaseBreadcrumb :title="seccion.titulo" :breadcrumbs="[]"></BaseBreadcrumb>

    <div class="seccion-fichas mx-3 mt-3">
      <p class="seccion-fichas__sub">{{ seccion.subtitulo }}</p>
      <section v-for="g in grupos" :key="g.nombre" class="seccion-fichas__grupo">
        <h2 v-if="g.nombre" class="seccion-fichas__grupo-titulo">
          <v-icon small color="primary" class="mr-2">{{ iconoGrupo(g.nombre) }}</v-icon>{{ g.nombre }}
        </h2>
        <div class="seccion-fichas__rejilla">
          <template v-for="f in g.fichas">
            <!-- Una acción se ejecuta aquí mismo: ahorra abrir otra pantalla. -->
            <button
              v-if="f.accion"
              :key="f.accion"
              type="button"
              class="seccion-fichas__ficha seccion-fichas__ficha--boton"
              :disabled="ocupado"
              @click="ejecutar(f.accion)"
            >
              <v-icon color="white" class="mr-3">{{ f.icono }}</v-icon>
              <span class="seccion-fichas__texto">
                <strong>{{ f.texto }}</strong>
                <small>{{ f.ayuda }}</small>
              </span>
            </button>
            <router-link v-else :key="f.ruta" :to="f.ruta" class="seccion-fichas__ficha" :class="{ 'seccion-fichas__ficha--boton': f.boton }">
              <v-icon :color="f.boton ? 'white' : 'primary'" class="mr-3">{{ f.icono }}</v-icon>
              <span class="seccion-fichas__texto">
                <strong>{{ f.texto }}</strong>
                <small>{{ f.ayuda }}</small>
              </span>
              <v-icon v-if="!f.boton" small class="ml-auto">mdi-chevron-right</v-icon>
            </router-link>
          </template>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import AppMenu from "./AppMenu.vue";

/**
 * Páginas de área, como /configuracion/general en el panel de Nubempresa: cada pantalla es una ficha
 * con una frase que dice para qué sirve, en vez de entradas sueltas en el menú lateral.
 */
const SECCIONES = {
  turnos: {
    titulo: "Turnos",
    subtitulo: "Abrir, cuadrar y cerrar la caja.",
    fichas: [
      { grupo: "", texto: "Cerrar turno", ayuda: "Cuenta lo que hay en caja y cierra el turno abierto.", ruta: "/pos/close-turn", icono: "mdi-store-minus-outline" },
      { grupo: "", texto: "Turnos", ayuda: "Todos los turnos con su cuadre, y el reporte fiscal para imprimir.", ruta: "/pos/turns", icono: "mdi-store-outline" },
    ],
  },
  reportes: {
    titulo: "Reportes",
    subtitulo: "Lo que pasó en la caja y en la cocina.",
    fichas: [
      { grupo: "Caja", texto: "Turnos y cuadres", ayuda: "Cada turno con su cuadre y el reporte fiscal para imprimir.", ruta: "/pos/turns", icono: "mdi-store-outline" },
      { grupo: "Caja", texto: "Órdenes", ayuda: "Todas las órdenes, con su estado, para buscarlas e imprimirlas.", ruta: "/pos/server-orders", icono: "mdi-text-box-check-outline" },
      { grupo: "Caja", texto: "Egresos aprobados", ayuda: "Lo que salió de la caja o se pagó con otro medio.", ruta: "/pos/expense-finalized", icono: "mdi-text-box-minus-outline" },
      { grupo: "Caja", texto: "Notas crédito", ayuda: "Devoluciones de facturas electrónicas, aprobadas y anuladas.", ruta: "/pos/credit-note-finalized", icono: "mdi-note-minus-outline", soloFacturador: true },
      { grupo: "Caja", texto: "Notas crédito DE", ayuda: "Devoluciones de ventas normales (documento equivalente).", ruta: "/pos/de-credit-note-finalized", icono: "mdi-note-minus-outline" },
      { grupo: "Cocina", texto: "Tiempos de cocina", ayuda: "Cuánto tarda cada pedido en salir, por estación y por día.", ruta: "/pos/kitchen-times", icono: "mdi-timer-outline", soloRestaurante: true },
    ],
  },
  ajustes: {
    titulo: "Configuración",
    subtitulo: "Cómo funciona esta caja.",
    fichas: [
      { grupo: "Caja", texto: "Caja", ayuda: "Tipo de recibo, consecutivos y opciones de esta caja.", ruta: "/pos/configuration", icono: "mdi-cast-variant" },
      { grupo: "Caja", texto: "Impresoras y balanza", ayuda: "Impresoras del equipo, impresión por categoría (cocina, bar…) y balanza.", ruta: "/pos/equipo", icono: "mdi-printer-settings", soloEscritorio: true },
      { grupo: "Ventas", texto: "Productos agotados", ayuda: "Marca lo que se acabó para que no se pueda vender.", ruta: "/pos/agotados", icono: "mdi-food-off-outline" },
      { grupo: "Ventas", texto: "Motivos de anulación", ayuda: "Las razones que se pueden elegir al anular un pedido.", ruta: "/pos/motivos-de-anulacion", icono: "mdi-cancel", soloRestaurante: true },
      { grupo: "Herramientas", texto: "Etiquetas", ayuda: "Imprime etiquetas de códigos de barras en la impresora de etiquetas.", ruta: "/pos/etiquetas", icono: "mdi-barcode", soloEscritorio: true },
      { grupo: "Herramientas", texto: "Ir al POS", ayuda: "Volver a la pantalla de ventas.", ruta: "/pos", icono: "mdi-cast-variant", boton: true },
      { grupo: "Herramientas", texto: "Subir sincronización", ayuda: "Envía al servidor las ventas guardadas en esta caja.", accion: "subirSincronizacion", icono: "mdi-cloud-upload-outline", boton: true },
      { grupo: "Herramientas", texto: "Descargar sincronización", ayuda: "Trae del servidor productos, precios y clientes, y recarga el POS.", accion: "descargarSincronizacion", icono: "mdi-cloud-sync-outline", boton: true },
    ],
  },
};

const ICONOS_GRUPO = { Caja: "mdi-cash-register", Ventas: "mdi-shopping-outline", Cocina: "mdi-chef-hat", Herramientas: "mdi-wrench-outline" };

export default {
  name: "SeccionFichas",
  components: { AppMenu },
  data() {
    return { ocupado: false };
  },
  methods: {
    iconoGrupo(nombre) {
      return ICONOS_GRUPO[nombre] || "mdi-folder-outline";
    },
    // Lo mismo que hacía la pantalla «Herramientas», sin salir de Configuración.
    async ejecutar(accion) {
      this.ocupado = true;
      try {
        if (accion === "subirSincronizacion") {
          await this.$pos.sincronizeSync();
        } else if (accion === "descargarSincronizacion") {
          const ok = await this.$pos.syncroRemoteToLocal();
          if (ok) {
            setTimeout(() => {
              this.$store.commit("setLoading", false);
              window.location.reload();
            }, 5000);
          }
        }
      } finally {
        this.ocupado = false;
      }
    },
  },
  computed: {
    seccion() {
      return SECCIONES[this.$route.meta.seccion] || SECCIONES.ajustes;
    },
    grupos() {
      const mapa = new Map();
      for (const f of this.seccion.fichas) {
        if (f.soloRestaurante && !this.$store.getters.isRestaurant) {
          continue;
        }
        // Lo que solo existe en la app de escritorio (impresoras, etiquetas).
        if (f.soloEscritorio && !window.posEscritorio) {
          continue;
        }
        // Las notas crédito de factura solo existen si la empresa factura electrónicamente.
        if (f.soloFacturador && this.$store.getters.getGeneralValue("gen_billing_invoice_electronically") != true) {
          continue;
        }
        mapa.set(f.grupo, [...(mapa.get(f.grupo) || []), f]);
      }
      return [...mapa].map(([nombre, fichas]) => ({ nombre, fichas }));
    },
  },
};
</script>

<style scoped>
.seccion-fichas__sub {
  margin: 0 0 16px;
  color: #5f6368;
}
.seccion-fichas__grupo {
  margin-bottom: 24px;
}
.seccion-fichas__grupo-titulo {
  display: flex;
  align-items: center;
  margin: 0 0 12px;
  padding-bottom: 6px;
  border-bottom: 2px solid #24a9e1;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #3c3c3b;
}
.seccion-fichas__rejilla {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
}
.seccion-fichas__ficha {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  color: inherit;
  text-decoration: none;
}
.seccion-fichas__ficha:hover {
  border-color: #24a9e1;
}
.seccion-fichas__ficha--boton {
  width: 100%;
  text-align: left;
  background: #24a9e1;
  border-color: #24a9e1;
  color: #fff;
  cursor: pointer;
}
.seccion-fichas__ficha--boton .seccion-fichas__texto small {
  color: rgba(255, 255, 255, 0.9);
}
.seccion-fichas__ficha--boton:hover {
  background: #1b93c6;
}
.seccion-fichas__ficha--boton:disabled {
  opacity: 0.6;
  cursor: wait;
}
.seccion-fichas__texto {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.seccion-fichas__texto small {
  color: #5f6368;
  font-size: 12px;
}
</style>
